import React, { ChangeEvent, FC, useCallback } from 'react'
import styles from 'styles/components/card.module.scss'
import { StaffPushSettingType, PermissionType } from 'types/staff'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef, getStaffPushSettings } from 'reducks/auth/selectors'
import { togglePushSettings } from 'reducks/auth/operations'
import { ToggleRoundButton } from 'components/Form'

type Props = {
  label: string
  permission: PermissionType
}

const StaffPushCardListDetail: FC<Props> = React.memo((props) => {
  const { label, permission } = props
  const dispatch = useDispatch()
  const staffPushSettings: StaffPushSettingType[] = useSelector((state: State) => getStaffPushSettings(state))

  const storeRef = useSelector((state: State) => getStoreRef(state))

  const staffPushSetting = staffPushSettings.find((_staffPushSetting) => {
    return _staffPushSetting.store_ref.id === storeRef.id
  })
  if (!staffPushSetting) return <></>

  const togglePushSetting = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(togglePushSettings(event.target.id as PermissionType))
    },
    [dispatch]
  )

  return (
    <div className={styles.list__detail}>
      <span>{label}</span>
      <ToggleRoundButton
        permission={permission}
        toggle={togglePushSetting}
        on={staffPushSetting.permissions.includes(permission)}
      />
    </div>
  )
})

export default StaffPushCardListDetail
